import React from "react";
import { useTranslation } from "react-i18next";
import { Mail, MessageSquare } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { arrivalChannelTabTriggerClassName } from "../utils/constants";
import type { Channel } from "../utils/types";
import { WhatsAppGlyph } from "./WhatsAppGlyph";

type ArrivalChannelTabsProps = {
  channel: Channel;
  onChannelChange: (channel: Channel) => void;
};

export function ArrivalChannelTabs({
  channel,
  onChannelChange,
}: ArrivalChannelTabsProps) {
  const { t } = useTranslation();

  return (
    <Tabs
      value={channel}
      onValueChange={(v) => onChannelChange(v as Channel)}
      className="w-full"
    >
      <div className="flex flex-col gap-3 border-b border-border sm:flex-row sm:items-center sm:justify-between sm:gap-6">
        <div className="flex min-h-10 shrink-0 items-center gap-2 text-base font-semibold leading-none text-foreground">
          <span className="flex size-8 items-center justify-center rounded-md bg-royal-glow-5 text-royal-glow-3">
            <Mail className="size-4" />
          </span>
          {t("layout.messagingSettingsPage.sectionTitle")}
        </div>

        <TabsList className="h-10 w-full min-w-0 items-center justify-start gap-0 rounded-none border-0 bg-transparent p-0 sm:h-auto sm:min-h-10 sm:w-auto sm:flex-1 sm:justify-end">
          <TabsTrigger
            value="sms"
            className={arrivalChannelTabTriggerClassName}
          >
            <MessageSquare className="size-4 shrink-0" />
            {t("layout.messagingSettingsPage.channels.sms")}
          </TabsTrigger>
          <TabsTrigger
            value="email"
            className={arrivalChannelTabTriggerClassName}
          >
            <Mail className="size-4 shrink-0" />
            {t("layout.messagingSettingsPage.channels.email")}
          </TabsTrigger>
          <TabsTrigger
            value="whatsapp"
            className={arrivalChannelTabTriggerClassName}
          >
            <WhatsAppGlyph className="size-4 shrink-0" />
            {t("layout.messagingSettingsPage.channels.whatsapp")}
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="sms" className="mt-4 outline-none">
        <p className="text-sm text-muted-foreground">
          {t("layout.messagingSettingsPage.channelHintSms")}
        </p>
      </TabsContent>
      <TabsContent value="email" className="mt-4 outline-none">
        <p className="text-sm text-muted-foreground">
          {t("layout.messagingSettingsPage.channelHintEmail")}
        </p>
      </TabsContent>
      <TabsContent value="whatsapp" className="mt-4 outline-none">
        <p className="text-sm text-muted-foreground">
          {t("layout.messagingSettingsPage.channelHintWhatsapp")}
        </p>
      </TabsContent>
    </Tabs>
  );
}
